// services/contact.service.js
import { 
  collection, 
  addDoc, 
  getDocs, 
  doc,
  updateDoc,
  deleteDoc,
  query, 
  where, 
  orderBy, 
  limit,
  serverTimestamp 
} from 'firebase/firestore';
import { db } from './firebase/firebaseconfig';

export const contactService = {
  // Submit contact form
  async submitContactForm(formData) {
    try {
      const docRef = await addDoc(collection(db, 'contactMessages'), {
        ...formData,
        createdAt: serverTimestamp(),
        status: 'new',
        read: false
      });
      return { success: true, id: docRef.id };
    } catch (error) {
      console.error('Error submitting contact form:', error);
      return { success: false, error: error.message };
    }
  },

  // Get recent contact messages (for admin)
  async getRecentMessages(limitCount = 10) {
    try {
      const q = query(
        collection(db, 'contactMessages'),
        orderBy('createdAt', 'desc'),
        limit(limitCount)
      );
      const querySnapshot = await getDocs(q);
      const messages = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return { success: true, messages };
    } catch (error) {
      console.error('Error fetching messages:', error);
      return { success: false, error: error.message };
    }
  },

  // Get messages by status
  async getMessagesByStatus(status) {
    try {
      const q = query(
        collection(db, 'contactMessages'),
        where('status', '==', status),
        orderBy('createdAt', 'desc')
      );
      const querySnapshot = await getDocs(q);
      const messages = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return { success: true, messages };
    } catch (error) {
      console.error('Error fetching messages by status:', error);
      return { success: false, error: error.message };
    }
  },

  // Update message status
  async updateMessageStatus(messageId, newStatus) {
    try {
      const messageRef = doc(db, 'contactMessages', messageId);
      await updateDoc(messageRef, {
        status: newStatus,
        updatedAt: serverTimestamp()
      });

      return {
        success: true,
        message: 'Statut du message mis à jour'
      };
    } catch (error) {
      console.error('Error updating message status:', error);
      return {
        success: false,
        error: error.message,
        message: 'Échec de la mise à jour du statut'
      };
    }
  },

  // Mark message as read
  async markAsRead(messageId) {
    try {
      const messageRef = doc(db, 'contactMessages', messageId);
      await updateDoc(messageRef, {
        read: true,
        readAt: serverTimestamp()
      });

      return {
        success: true,
        message: 'Message marqué comme lu'
      };
    } catch (error) {
      console.error('Error marking message as read:', error);
      return {
        success: false,
        error: error.message,
        message: 'Échec de la mise à jour'
      };
    }
  },

  // Delete message
  async deleteMessage(messageId) {
    try {
      const messageRef = doc(db, 'contactMessages', messageId);
      await deleteDoc(messageRef);

      return {
        success: true,
        message: 'Message supprimé avec succès'
      };
    } catch (error) {
      console.error('Error deleting message:', error);
      return {
        success: false,
        error: error.message,
        message: 'Échec de la suppression du message'
      };
    }
  },

  // Get message statistics
  async getMessageStats() {
    try {
      const messagesRef = collection(db, 'contactMessages');
      const querySnapshot = await getDocs(messagesRef);
      
      let total = 0;
      let newMessages = 0;
      let inProgress = 0;
      let resolved = 0;
      let unread = 0;

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        total++;
        
        if (!data.read) unread++;
        
        if (data.status === 'new') newMessages++;
        else if (data.status === 'in-progress') inProgress++;
        else if (data.status === 'resolved') resolved++;
      });

      return {
        success: true,
        stats: {
          total,
          new: newMessages,
          inProgress,
          resolved,
          unread
        }
      };
    } catch (error) {
      console.error('Error getting message stats:', error);
      return {
        success: false,
        error: error.message,
        stats: {
          total: 0,
          new: 0,
          inProgress: 0,
          resolved: 0,
          unread: 0
        }
      };
    }
  }
};

export default contactService;